"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

/** Symetrie avec [locale]/error.tsx — skip Sentry sur erreurs reseau
 *  transitoires (Safari iOS "Load failed", AbortError, etc.). */
function isTransientNetworkError(error: Error): boolean {
  const msg = (error.message || "").toLowerCase();
  const name = (error.name || "").toLowerCase();
  return (
    name === "aborterror" ||
    msg === "load failed" ||
    msg.includes("failed to fetch") ||
    msg.includes("networkerror") ||
    msg.includes("network error") ||
    msg.includes("the user aborted") ||
    msg.includes("the operation was aborted") ||
    msg.includes("network request failed") ||
    msg.includes("net::err_")
  );
}

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (isTransientNetworkError(error)) return;
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="fr">
      <body>
        <main
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            background: "#ffffff",
            color: "#0f1c17",
          }}
        >
          <div style={{ maxWidth: 480, textAlign: "center" }}>
            <h1 style={{ fontSize: 28, margin: "0 0 12px", fontWeight: 600 }}>
              Erreur critique
            </h1>
            <p style={{ color: "#5a6860", margin: "0 0 24px" }}>
              Sahha rencontre un incident. Notre équipe a été notifiée.
            </p>
            {error.digest ? (
              <p style={{ fontSize: 12, color: "#8c9590", marginBottom: 24 }}>
                Référence&nbsp;: <code>{error.digest}</code>
              </p>
            ) : null}
            <button
              type="button"
              onClick={reset}
              style={{
                padding: "12px 24px",
                borderRadius: 9999,
                background: "#1570ef",
                color: "#ffffff",
                border: 0,
                cursor: "pointer",
                fontSize: 15,
                fontWeight: 500,
              }}
            >
              Réessayer
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
